<div class="swipe-enabled container">
	<lib-content
		class="content"
		*rxLet="page$ let page"
		[page]="page"
	></lib-content>

	<lib-social></lib-social>
</div>


